/* Stefánsbúð: íslenskar þýðingar á texta sem Shopify sendir á ensku
   (röðun, heiti sía og valkosta). Breytir aðeins textahánútum sem passa nákvæmlega. */
(function () {
  if (window.sbI18n) return;
  window.sbI18n = true;
  var MAP = {
    'Featured': 'Valið af okkur',
    'Most relevant': 'Mest viðeigandi',
    'Relevance': 'Mest viðeigandi',
    'Best selling': 'Vinsælast',
    'Alphabetically, A-Z': 'Stafrófsröð, A–Ö',
    'Alphabetically, Z-A': 'Stafrófsröð, Ö–A',
    'Price, low to high': 'Verð, lægst fyrst',
    'Price, high to low': 'Verð, hæst fyrst',
    'Date, old to new': 'Elst fyrst',
    'Date, new to old': 'Nýjast fyrst',
    'Price': 'Verð',
    'Availability': 'Framboð',
    'In stock': 'Til á lager',
    'Out of stock': 'Uppselt',
    'Product type': 'Vörutegund',
    'Brand': 'Merki',
    'Vendor': 'Merki',
    'Size': 'Stærð',
    'Color': 'Litur',
    'Colour': 'Litur',
    'Denominations': 'Upphæð',
    'Title': 'Útgáfa'
  };
  var SEL = '.filter-group__heading__text, .filter-group__item__text, .filter-group__applied-item__text, ' +
    '.link-dropdown__link, .link-dropdown__button-text, .option-selector .label, legend.label, ' +
    '.product-form__error, .js-error, .cart-item__option-name, .cart-item__variant, .variant-title';
  function tr(node) {
    var t = node.nodeValue, s = t.trim();
    if (!s) return;
    if (MAP[s]) { node.nodeValue = t.replace(s, MAP[s]); return; }
    var m = s.match(/^(Veldu|Choose a|Select)\s+(.+)$/);
    if (m && MAP[m[2]]) { node.nodeValue = t.replace(s, 'Veldu ' + MAP[m[2]].toLowerCase()); return; }
    var c = s.match(/^([A-Za-z ]+):\s*(.*)$/);
    if (c && MAP[c[1]]) node.nodeValue = t.replace(c[1], MAP[c[1]]);
  }
  function run(root) {
    var els = (root.matches && root.matches(SEL)) ? [root] : [];
    if (root.querySelectorAll) els = els.concat([].slice.call(root.querySelectorAll(SEL)));
    els.forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) tr(n);
    });
  }
  function start() {
    run(document.body);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'characterData') { var p = m.target.parentElement; if (p && p.closest(SEL)) tr(m.target); }
        m.addedNodes && [].forEach.call(m.addedNodes, function (n) {
          if (n.nodeType === 1) run(n);
          else if (n.nodeType === 3 && n.parentElement && n.parentElement.closest(SEL)) tr(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
